import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { usePatrolsStore } from "./patrolsStore/patrolsStore";

export const SiteDropDownPatrols = ({
  navBarCollapsed,
}: {
  navBarCollapsed: boolean;
}) => {
  const {
    filtersPatrols,
    setFiltersPatrols,
    siteOptionsPatrols,
    setCameraOptionsPatrols,
    loadingSitesPatrols,
    setLoadingCamerasPatrols,
  } = usePatrolsStore();

  const siteNamesMap = new Map();
  siteOptionsPatrols.forEach((object: any) => {
    siteNamesMap.set(object.id, object.name);
  });

  // Convert stored site ID to single object for the Autocomplete (single selection only)
  const siteIds = Array.isArray(filtersPatrols.site) ? filtersPatrols.site : [];
  const selectedSiteObject =
    siteIds.length > 0
      ? (() => {
          const siteId = siteIds[0];
          const siteName = siteNamesMap.get(siteId);
          const siteIndex = siteOptionsPatrols.findIndex(
            (site: any) => site.id === siteId
          );
          return {
            id: siteId,
            name: siteName,
            index: siteIndex,
          };
        })()
      : null;

  return (
    <div>
      <Autocomplete
        value={selectedSiteObject}
        disablePortal
        options={
          siteOptionsPatrols[0]
            ? siteOptionsPatrols.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => (option?.name ?? option) || ""}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        loading={loadingSitesPatrols}
        onChange={(event, value: any) => {
          if (value) {
            localStorage.setItem(
              "siteDropDownValue",
              JSON.stringify([value.name])
            );
            setFiltersPatrols((previousState: any) => ({
              ...previousState,
              site: [value.id],
              camera: "",
            }));
          } else {
            setCameraOptionsPatrols([]);
            setFiltersPatrols((previousState: any) => ({
              ...previousState,
              site: [],
              camera: [],
            }));
            setLoadingCamerasPatrols(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSitesPatrols ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            sx={!navBarCollapsed ? { width: 250 } : { width: 275 }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
